<lxm-dialog [dialogRef]="dialogRef" #dialog> 
</lxm-dialog>